import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { RegisterModule } from 'src/app/common-components/register/register.module';
import { AccountUserRegisterComponent } from './containers/account-user-register/account-user-register.component';
import { RoleUserRegisterComponent } from './containers/role-user-register/role-user-register.component';
import { SystemUserRegisterComponent } from './containers/system-user-register/system-user-register.component';
import { UserRegisterComponent } from './containers/user-register.component';
import { UserRegisterEffects } from './state/user-register.effects';
import { userRegisterFeatureKey, userRegisterReducer } from './state/user-register.reducer';
import { UserRegisterViewComponent } from './views/user-register-view.component';

@NgModule({
   declarations: [
      UserRegisterComponent,
      UserRegisterViewComponent,
      RoleUserRegisterComponent,
      SystemUserRegisterComponent,
      AccountUserRegisterComponent,
   ],
   exports: [RoleUserRegisterComponent],
   imports: [
      CommonModule,
      FormsModule,
      LcsCallStatePipeModule,
      LcsLoadingOverlayModule,
      LcsResponsiveTableModule,
      MatButtonModule,
      MatInputModule,
      MatTooltipModule,
      MatIconModule,
      ReactiveFormsModule,
      RouterModule,
      RegisterModule,
      ScrollingModule,
      MatMenuModule,
      EffectsModule.forFeature([UserRegisterEffects]),
      StoreModule.forFeature(userRegisterFeatureKey, userRegisterReducer),
      MatSlideToggleModule,
   ],
})
export class UserRegisterModule {}
